import "./listItemBody.scss";
// vendors
import React from 'react';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;
import classnames from 'classnames';
import PropTypes from 'prop-types';
// components
import { OKButton } from 'commonsComponents/OKButton';

const ListItemBody = ({ card, isFullRates, onClick }) => {
    const { accountRate } = card;
    const { simpleRate, doubleRate } = accountRate;
    const { tae, tin, superIndex } = simpleRate;
    const { tae: taeBonified, tin: tinBonified, superIndex: superIndexBonified } = doubleRate || {};


    const renderAdvantagesLink = () => {
        const isDoubleRate = !!doubleRate;
        const classes = classnames('list-item-body__advantages', {
            'list-item-body__advantages--reducedSpacing': isDoubleRate
        });
        return (
            <div className={classes}>
                <OKButton customColors modifier="link-emphasize" onClick={onClick}>
                    <FormattedText value="savingsAccounts-savingsAccounts_savingsCardLinkLabel" />
                </OKButton>
            </div>
        )
    }

    const renderRate = (taeValue, tinValue, superIndexValue, backgroundColor) => (
        <div className="list-item-body__rate">
            <div className="list-item-body__rate-tae" style={{ backgroundColor }}>
                <strong>
                    <FormattedText
                        value="contractsView-contractView_depositOfferDetailTae"
                        injectedStrings={[taeValue]}
                    />
                    <sup>{superIndexValue}</sup>
                </strong>
            </div>
            <FormattedText
                value="contractsView-contractView_depositOfferDetailTin"
                injectedStrings={[tinValue]}
            />
        </div>
    );

    const renderInterestRate = () => {
        if (isFullRates) {
            return (
                <React.Fragment>
                    {renderRate(tae, tin, superIndex, "#e1e1f3")}
                    {doubleRate && (
                        <React.Fragment>
                            <div className="list-item-body__separator" />
                            {renderRate(taeBonified, tinBonified, superIndexBonified)}
                        </React.Fragment>
                    )}
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <div className="list-item-body__rate-tae">
                    <strong style={{ backgroundColor: "#e1e1f3" }}>
                        <FormattedText value="contractsView-contractView_depositOfferDetailTin" injectedStrings={[tin]} />
                        <sup>{superIndex}</sup>
                    </strong>
                </div>
                {doubleRate && (
                    <React.Fragment>
                        <div className="list-item-body__separator" />
                        <div className="list-item-body__rate">
                            <FormattedText
                                value="contractsView-contractView_depositOfferDetailTin"
                                injectedStrings={[tinBonified]}
                            />
                            <sup>{superIndexBonified}</sup>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    };
    return (
        <div className="list-item-body">
            {renderInterestRate(card)}
            {renderAdvantagesLink(card)}
        </div>
    );
};

ListItemBody.propTypes = {
    card: PropTypes.shape({
        accountRate: PropTypes.shape({
            simpleRate: PropTypes.shape({
                tae: PropTypes.string.isRequired,
                tin: PropTypes.string.isRequired,
                superIndex: PropTypes.string.isRequired,
            }).isRequired,
            doubleRate: PropTypes.shape({
                tae: PropTypes.string,
                tin: PropTypes.string,
                superIndex: PropTypes.string,
            }),
        }).isRequired,
    }).isRequired,
    isFullRates: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ListItemBody;
